<template>
  <v-app>
    <v-navigation-drawer
      app
      color="primary"
    >
    </v-navigation-drawer>
    <v-main class="derecha">
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
          >
            <v-card
              class="elevation-3"
              tile
            >
              <v-card-title>
                Solicitud de recuperación de contraseña
              </v-card-title>
              <v-form
                @submit.prevent="requestPassReset"
              >
              <v-card-text>
                    <h4>
                        Introduzca su correo electrónico para el cambio de su contraseña
                    </h4>
                <v-text-field
                  v-model="form.email"
                  label="Email"
                  name="email"
                  append-icon="mdi-at"
                  type="email"
                  :error-messages="errorsEmail"
                  @blur="$v.form.email.$touch()"
                  :hide-details="!$v.form.email.$error"
                />
                <v-btn
                  name="submit"
                  type="submit"
                  outlined
                  class="my-5"
                  block
                >
                  Enviar solicitud
                </v-btn>
              </v-card-text>
                </v-form>
                <v-col
                cols="12"
                sm="8"
                >
                <router-link :to="{ name: 'Login' }">
                      Volver al login
                </router-link>
              </v-col>

            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import types from '@/types';
import { required, email } from 'vuelidate/lib/validators';

export default {
  data() {
    return {
      form: {
        email: '',
      },
    };
  },

  validations: {
    form: {
      email: {
        required,
        email,
      },
    },
  },

  computed: {
    errorsEmail() {
      const errors = [];
      if (!this.$v.form.email.$dirty) { return errors; }
      if (!this.$v.form.email.required) {
        errors.push('Enter your email.');
      }
      if (!this.$v.form.email.email) {
        errors.push('Enter a valid email.');
      }
      return errors;
    },
  },

  methods: {
    ...mapMutations({
      [types.SHOW_BUSY]: `${types.APP}/${types.SHOW_BUSY}`,
      [types.HIDE_BUSY]: `${types.APP}/${types.HIDE_BUSY}`,
      [types.SHOW_SUCCESS]: `${types.APP}/${types.SHOW_SUCCESS}`,
      [types.SHOW_WARNING]: `${types.APP}/${types.SHOW_WARNING}`,
    }),
    ...mapActions({
      [types.REQUEST_PASSWORD_RESET]: `${types.USER}/${types.REQUEST_PASSWORD_RESET}`,
    }),

    requestPassReset() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }
      this[types.SHOW_BUSY]('Sending password reset...');
      this[types.REQUEST_PASSWORD_RESET](this.form)
        .then(() => {
          this[types.SHOW_SUCCESS]('Your password request was sent.');
          setTimeout(() => {
            this.$router.push({ name: 'Login' });
          }, 500);
        })
        .catch(() => {
          this[types.SHOW_WARNING]('La petición no pudo ser procesada');
        })
        .finally(() => {
          this[types.HIDE_BUSY]();
        });
    },

  },
};
</script>

<style>
.derecha {
  background-color: rgb(156, 153, 153);
}
</style>



// WEBPACK FOOTER //
// src/views/user/RequestPasswordReset.vue